// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {setArrayKey} from "../../utils/misc";


class RoomSubscriberCreateModal extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonColor: 'primary',
            modalLabel: 'Добавить участника',
            modalIcon: AssignmentIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            ready: true,
        })
    }

    async retrieveFields() {
        let url = `room_subscriber/create_form/`;
        const api = new BaseApi();
        const params = {
            fields: JSON.stringify(
                [
                    'subscriber',
                    'xtype',
                ]
            )
        }
        let response = await api.get(
            url,
            params
        );
        let formFields = response.data

        url = `subscriber/`;
        response = await api.get(
            url,
            {
                active: true,
                page_size: 10000,
            }
        );

        formFields = setArrayKey(
            formFields,
            'name',
            'subscriber',
            'options',
            response.data.results.filter(each => !this.props.subscribers.map(s => s.id).includes(each.id)).map((each) => (
                {
                    value: each.id,
                    label: `${each.user.first_name} ${each.user.last_name}`
                }
            ))
        )
        formFields = setArrayKey(
            formFields,
            'name',
            'xtype',
            'options',
            [
                {
                    value: 'COMMON',
                    label: 'Обычный',
                },
                {
                    value: 'ADMIN',
                    label: 'Администратор',
                },
            ]
        )
        return (formFields)
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        formDataObj.room = this.props.room.id
        const url = `room_subscriber/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (this.props.callBack){
                await this.props.callBack()
            }
            this.setModalOpenFalse();
        }
        return response
    }
}

export default RoomSubscriberCreateModal